import { ActivatedRoute } from '@angular/router';
import { IsiClientReportDetail, IsiPersonReportDetail, ISICountryWisePerson,
         ISICountryWiseEntity, ISIstructureWiseEntity } from './isi-report-detail.model';
import { ReportsService } from './../reports.service';
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'isi-report-detail',
  templateUrl: './isi-report-detail.component.html',
  styleUrls: ['./isi-report-detail.component.css'],
  providers: [ReportsService]
})
export class IsiReportDetailComponent implements OnInit {
  subOfficeId: any;
  clientFromNetherland = new IsiClientReportDetail;
  clientNotFromNetherland = new IsiClientReportDetail;
  highRiskBasedDV = new IsiClientReportDetail;
  mediumRiskBasedDV = new IsiClientReportDetail;
  lowRiskBasedDV = new IsiClientReportDetail;
  bfiClient = new IsiClientReportDetail;

  fiveLayersClient = new IsiClientReportDetail;
  dVWithDomicilieSecServices = new IsiClientReportDetail;
  dVWithManagementServices = new IsiClientReportDetail;
  dVWithActAsTrusteeService = new IsiClientReportDetail;
  dVWithDomiciliePlus = new IsiClientReportDetail;
  // dVWithNomineeShareholders = new IsiClientReportDetail;
  dVActivityHolding = new IsiClientReportDetail;
  dVActivityFinancing = new IsiClientReportDetail;
  dVActivityOperational = new IsiClientReportDetail;
  dVActivityOther = new IsiClientReportDetail;
  commanditaireVennootInNL = new IsiClientReportDetail;
  commanditaireVennootNotInNL = new IsiClientReportDetail;
  commanditaireVennootGeenWTT = new IsiClientReportDetail;
  commanditaireVennootDomiciliePlus = new IsiClientReportDetail;
  commanditaireVennootPartner = new IsiClientReportDetail;
  commanditaireVennootPartnerDirectorAndDomciliePlusServices = new IsiClientReportDetail;
  coorporatieClients = new IsiClientReportDetail;
  coorporatieWithDirectie = new IsiClientReportDetail;
  coorporatieWithDomiciliePlus = new IsiClientReportDetail;
  coorporatieWithWfft = new IsiClientReportDetail;
  managerialObjectCompany = new IsiClientReportDetail;
  dVWithBranchesOutsideNL = new IsiClientReportDetail;
  dVStichting = new IsiClientReportDetail;
  clientWithRealEstateDevelopmentActivities = new IsiClientReportDetail;
  clientWithRealEstateTransactionActivities = new IsiClientReportDetail;
  clientWithRealEstateManagementActivities = new IsiClientReportDetail;
  operationalConsultancyDV = new IsiClientReportDetail;
  operationalTradeDV = new IsiClientReportDetail;
  operationalProductionDV = new IsiClientReportDetail;
  dVBuitendirecteuren = new IsiClientReportDetail;
  offBoardedClient = new IsiClientReportDetail;
  uboInNL = new IsiPersonReportDetail;
  pepAndUBO = new IsiPersonReportDetail;
  countryWiseUBO = new ISICountryWisePerson;
  countryWisePEP = new ISICountryWisePerson;
  countryWiseBranch = new ISICountryWiseEntity;
  countryWiseParticipations = new ISICountryWiseEntity;
  countryWiseFeeders = new ISICountryWiseEntity;
  privateStructure = new IsiClientReportDetail;
  structureDVWithTrusts = new ISIstructureWiseEntity;
  structureDVWithTrustOfficeAsNomineeShareholder = new ISIstructureWiseEntity;

  constructor(private reportService: ReportsService,
    private route: ActivatedRoute) { }

  ngOnInit() {
    this.route
      .params
      .subscribe(params => {
        if (params['officeId'] === 'headOffice') {
          this.subOfficeId = params['officeId'];
          this.loadHeadOffice(params['year']);
        } else {
          this.subOfficeId = params['officeId'];
          this.loadSubOffice(params['year']);
        };
      });
  }
  getClientForISI(year, functionName, obj: IsiClientReportDetail) {
    this.reportService.getClientForISIReport(functionName, year)
      .subscribe(clients => {
        obj.clients = clients.arrResult;
        obj.isLoading = false;
      });
  }

  getPersonForISI(year, functionName, obj: IsiPersonReportDetail) {
    this.reportService.getPersonForISIReport(functionName, year)
      .subscribe(persons => {
        obj.person = persons.arrResult;
        obj.isLoading = false;
      });
  }

  getCountryWisePerson(year, functionName, obj: ISICountryWisePerson) {
    this.reportService.getCountryWisePersonForISIReport(functionName, year)
      .subscribe(persons => {
        obj.data = persons.arrResult;
        obj.isLoading = false;
      });
  }

  getCountryWiseEntity(year, functionName, obj: ISICountryWiseEntity) {
    this.reportService.getCountryWiseEntityForISIReport(functionName, year)
      .subscribe(response => {
        obj.data = response.arrResult;
        obj.isLoading = false;
      });
  }

  getStructureWiseEntity(year, functionName, obj: ISIstructureWiseEntity) {
    this.reportService.getStructureWiseEntityForISIReport(functionName, year)
      .subscribe(response => {
        obj.data = response.arrResult;
        obj.isLoading = false;
      });
  }

  getClientForISISub(year, functionName, obj: IsiClientReportDetail, orgId) {
    this.reportService.getClientForISISubReport(functionName, orgId, year)
      .subscribe(clients => {
        obj.clients = clients.arrResult;
        obj.isLoading = false;
      });
  }

  getPersonForISISub(year, functionName, obj: IsiPersonReportDetail, orgId) {
    this.reportService.getPersonForISISubReport(functionName, orgId, year)
      .subscribe(persons => {
        obj.person = persons.arrResult;
        obj.isLoading = false;
      });
  }

  getCountryWisePersonSub(year, functionName, obj: ISICountryWisePerson, orgId) {
    this.reportService.getCountryWisePersonForISISubReport(functionName, orgId, year)
      .subscribe(persons => {
        obj.data = persons.arrResult;
        obj.isLoading = false;
      });
  }

  getCountryWiseEntitySub(year, functionName, obj: ISICountryWiseEntity, orgId) {
    this.reportService.getCountryWiseEntityForISISubReport(functionName, orgId, year)
      .subscribe(persons => {
        obj.data = persons.arrResult;
        obj.isLoading = false;
      });
  }

  getStructureWiseEntitySub(year, functionName, obj: ISICountryWiseEntity, orgId) {
    this.reportService.getStructureEntityForISISubReport(functionName, orgId, year)
      .subscribe(persons => {
        obj.data = persons.arrResult;
        obj.isLoading = false;
      });
  }

  loadSubOffice(year) {
    this.clientFromNetherland.isLoading = true;
    this.getClientForISISub(year, 'getClientFromNetherlands', this.clientFromNetherland, this.subOfficeId);
    this.clientNotFromNetherland.isLoading = true;
    this.getClientForISISub(year, 'getClientNotFromNetherlands', this.clientNotFromNetherland, this.subOfficeId);
    this.highRiskBasedDV.isLoading = true;
    this.getClientForISISub(year, 'getHighRiskBasedDV', this.highRiskBasedDV, this.subOfficeId);
    this.mediumRiskBasedDV.isLoading = true;
    this.getClientForISISub(year, 'getMediumRiskBasedDV', this.mediumRiskBasedDV, this.subOfficeId);
    this.lowRiskBasedDV.isLoading = true;
    this.getClientForISISub(year, 'getLowRiskBasedDV', this.lowRiskBasedDV, this.subOfficeId);
    this.bfiClient.isLoading = true;
    this.getClientForISISub(year, 'getBFIClient', this.bfiClient, this.subOfficeId);
    this.fiveLayersClient.isLoading = true;
    this.getClientForISISub(year, 'getDVWithMoreThanFiveLayers', this.fiveLayersClient, this.subOfficeId)
    this.dVWithManagementServices.isLoading = true;
    this.getClientForISISub(year, 'getDVWithManagementServices', this.dVWithManagementServices, this.subOfficeId);
    // this.dVWithNomineeShareholders.isLoading = true;
    // this.getClientForISI(year, 'getDVWithNomineeShareholders', this.dVWithNomineeShareholders);
    this.dVActivityHolding.isLoading = true;
    this.getClientForISI(year, 'getDVActivityHolding', this.dVActivityHolding);
    this.dVActivityFinancing.isLoading = true;
    this.getClientForISI(year, 'getDVActivityFinancing', this.dVActivityFinancing);
    this.dVActivityOperational.isLoading = true;
    this.getClientForISI(year, 'getDVActivityOperational', this.dVActivityOperational);
    this.dVActivityOther.isLoading = true;
    this.getClientForISI(year, 'getDVActivityOther', this.dVActivityOther);
    this.commanditaireVennootInNL.isLoading = true;
    this.getClientForISISub(year, 'getCommanditaireVennootInNL', this.commanditaireVennootInNL, this.subOfficeId);
    this.commanditaireVennootNotInNL.isLoading = true;
    this.getClientForISISub(year, 'getCommanditaireVennootNotInNL', this.commanditaireVennootNotInNL, this.subOfficeId);
    this.commanditaireVennootPartner.isLoading = true;
    this.getClientForISISub(year, 'getCommanditaireVennootPartner', this.commanditaireVennootPartner, this.subOfficeId);
    this.coorporatieClients.isLoading = true;
    this.getClientForISISub(year, 'getCoorporatie', this.coorporatieClients, this.subOfficeId);
    this.coorporatieWithDirectie.isLoading = true;
    this.getClientForISISub(year, 'getCoorporatieWithDirectie', this.coorporatieWithDirectie, this.subOfficeId);
    this.managerialObjectCompany.isLoading = true;
    this.getClientForISISub(year, 'getManagerialObjectCompany', this.managerialObjectCompany, this.subOfficeId);
    this.dVWithBranchesOutsideNL.isLoading = true;
    this.getClientForISISub(year, 'getDVWithBranchesOutsideNL', this.dVWithBranchesOutsideNL, this.subOfficeId);
    this.dVStichting.isLoading = true;
    this.getClientForISISub(year, 'getDVStichting', this.dVStichting, this.subOfficeId);
    this.clientWithRealEstateDevelopmentActivities.isLoading = true;
    this.getClientForISISub(year, 'getClientWithRealEstateDevelopmentActivities',
      this.clientWithRealEstateDevelopmentActivities, this.subOfficeId);
    this.clientWithRealEstateTransactionActivities.isLoading = true;
    this.getClientForISISub(year, 'getClientWithRealEstateTransactionActivities',
      this.clientWithRealEstateTransactionActivities, this.subOfficeId);
    this.clientWithRealEstateManagementActivities.isLoading = true;
    this.getClientForISISub(year, 'getClientWithRealEstateManagementActivities',
      this.clientWithRealEstateManagementActivities, this.subOfficeId);
    this.operationalConsultancyDV.isLoading = true;
    this.getClientForISISub(year, 'getOperationalConsultancyDV',
      this.operationalConsultancyDV, this.subOfficeId);
    this.operationalTradeDV.isLoading = true;
    this.getClientForISISub(year, 'getOperationalTradeDV',
      this.operationalTradeDV, this.subOfficeId);
    this.operationalProductionDV.isLoading = true;
    this.getClientForISISub(year, 'getOperationalProductionDV',
      this.operationalProductionDV, this.subOfficeId);
    this.dVBuitendirecteuren.isLoading = true;
    this.getClientForISISub(year, 'getDVBuitendirecteuren',
      this.dVBuitendirecteuren, this.subOfficeId);
    this.offBoardedClient.isLoading = true;
    this.getClientForISISub(year, 'getOffBoardedClient',
      this.offBoardedClient, this.subOfficeId);
    this.uboInNL.isLoading = true;
    this.getPersonForISISub(year, 'getUBOFromNL', this.uboInNL, this.subOfficeId);
    this.pepAndUBO.isLoading = true;
    this.getPersonForISISub(year, 'getPEPUBO', this.pepAndUBO, this.subOfficeId);
    this.countryWiseUBO.isLoading = true;
    this.getCountryWisePersonSub(year, 'UBOs', this.countryWiseUBO, this.subOfficeId);
    this.countryWisePEP.isLoading = true;
    this.getCountryWisePersonSub(year, 'peps', this.countryWisePEP, this.subOfficeId);
    this.countryWiseBranch.isLoading = true;
    this.getCountryWiseEntitySub(year, 'branches', this.countryWiseBranch, this.subOfficeId);
    this.countryWiseParticipations.isLoading = true;
    this.getCountryWiseEntitySub(year, 'participations', this.countryWiseParticipations, this.subOfficeId);
    this.countryWiseFeeders.isLoading = true;
    this.getCountryWiseEntitySub(year, 'feeders', this.countryWiseFeeders, this.subOfficeId);
    this.structureDVWithTrusts.isLoading = true;
    this.getStructureWiseEntitySub(year, 'getDVWithTrusts', this.structureDVWithTrusts, this.subOfficeId);
    this.structureDVWithTrustOfficeAsNomineeShareholder.isLoading = true;
    this.getStructureWiseEntitySub(year, 'getDVWithTrustOfficeAsNomineeShareholder',
                                    this.structureDVWithTrustOfficeAsNomineeShareholder, this.subOfficeId);
  }

  loadHeadOffice(year) {
    this.clientFromNetherland.isLoading = true;
    this.getClientForISI(year, 'getClientFromNetherlands', this.clientFromNetherland);
    this.clientNotFromNetherland.isLoading = true;
    this.getClientForISI(year, 'getClientNotFromNetherlands', this.clientNotFromNetherland);
    this.highRiskBasedDV.isLoading = true;
    this.getClientForISI(year, 'getHighRiskBasedDV', this.highRiskBasedDV);
    this.mediumRiskBasedDV.isLoading = true;
    this.getClientForISI(year, 'getMediumRiskBasedDV', this.mediumRiskBasedDV);
    this.lowRiskBasedDV.isLoading = true;
    this.getClientForISI(year, 'getLowRiskBasedDV', this.lowRiskBasedDV);
    this.bfiClient.isLoading = true;
    this.getClientForISI(year, 'getBFIClient', this.bfiClient);
    this.fiveLayersClient.isLoading = true;
    this.getClientForISI(year, 'getDVWithMoreThanFiveLayers', this.fiveLayersClient);
    this.privateStructure.isLoading = true;
    this.getClientForISI(year, 'getPrivateStructure', this.privateStructure);
    this.dVWithDomicilieSecServices.isLoading = true;
    this.getClientForISI(year, 'getDVWithDomicilieSecServices', this.dVWithDomicilieSecServices);
    this.dVWithManagementServices.isLoading = true;
    this.getClientForISI(year, 'getDVWithManagementServices', this.dVWithManagementServices);
    this.dVWithActAsTrusteeService.isLoading = true;
    this.getClientForISI(year, 'getDVWithActAsTrusteeService', this.dVWithActAsTrusteeService);
    this.dVWithDomiciliePlus.isLoading = true;
    this.getClientForISI(year, 'getDVWithDomiciliePlus', this.dVWithDomiciliePlus);
    // this.dVWithNomineeShareholders.isLoading = true;
    // this.getClientForISI(year, 'getDVWithNomineeShareholders', this.dVWithNomineeShareholders);
    this.dVActivityHolding.isLoading = true;
    this.getClientForISI(year, 'getDVActivityHolding', this.dVActivityHolding);
    this.dVActivityFinancing.isLoading = true;
    this.getClientForISI(year, 'getDVActivityFinancing', this.dVActivityFinancing);
    this.dVActivityOperational.isLoading = true;
    this.getClientForISI(year, 'getDVActivityOperational', this.dVActivityOperational);
    this.dVActivityOther.isLoading = true;
    this.getClientForISI(year, 'getDVActivityOther', this.dVActivityOther);
    this.commanditaireVennootInNL.isLoading = true;
    this.getClientForISI(year, 'getCommanditaireVennootInNL', this.commanditaireVennootInNL);
    this.commanditaireVennootNotInNL.isLoading = true;
    this.getClientForISI(year, 'getCommanditaireVennootNotInNL', this.commanditaireVennootNotInNL);
    this.commanditaireVennootGeenWTT.isLoading = true;
    this.getClientForISI(year, 'getCommanditaireVennootGeenWTT', this.commanditaireVennootGeenWTT);
    this.commanditaireVennootDomiciliePlus.isLoading = true;
    this.getClientForISI(year, 'getCommanditaireVennootDomiciliePlus', this.commanditaireVennootDomiciliePlus);
    this.commanditaireVennootPartner.isLoading = true;
    this.getClientForISI(year, 'getCommanditaireVennootPartner', this.commanditaireVennootPartner);
    this.commanditaireVennootPartnerDirectorAndDomciliePlusServices.isLoading = true;
    this.getClientForISI(year, 'getCommanditaireVennootPartnerDirectorAndDomciliePlusServices',
      this.commanditaireVennootPartnerDirectorAndDomciliePlusServices);
    this.coorporatieClients.isLoading = true;
    this.getClientForISI(year, 'getCoorporatie', this.coorporatieClients);
    this.coorporatieWithDirectie.isLoading = true;
    this.getClientForISI(year, 'getCoorporatieWithDirectie', this.coorporatieWithDirectie);
    this.coorporatieWithDomiciliePlus.isLoading = true;
    this.getClientForISI(year, 'getCoorporatieWithDomiciliePlus', this.coorporatieWithDomiciliePlus);
    this.coorporatieWithWfft.isLoading = true;
    this.getClientForISI(year, 'getCoorporatieWithWfft', this.coorporatieWithWfft);
    this.managerialObjectCompany.isLoading = true;
    this.getClientForISI(year, 'getManagerialObjectCompany', this.managerialObjectCompany);
    this.dVWithBranchesOutsideNL.isLoading = true;
    this.getClientForISI(year, 'getDVWithBranchesOutsideNL', this.dVWithBranchesOutsideNL);
    this.dVStichting.isLoading = true;
    this.getClientForISI(year, 'getDVStichting', this.dVStichting);
    this.clientWithRealEstateDevelopmentActivities.isLoading = true;
    this.getClientForISI(year, 'getClientWithRealEstateDevelopmentActivities', this.clientWithRealEstateDevelopmentActivities);
    this.clientWithRealEstateTransactionActivities.isLoading = true;
    this.getClientForISI(year, 'getClientWithRealEstateTransactionActivities', this.clientWithRealEstateTransactionActivities);
    this.clientWithRealEstateManagementActivities.isLoading = true;
    this.getClientForISI(year, 'getClientWithRealEstateManagementActivities', this.clientWithRealEstateManagementActivities);
    this.operationalConsultancyDV.isLoading = true;
    this.getClientForISI(year, 'getOperationalConsultancyDV', this.operationalConsultancyDV);
    this.operationalTradeDV.isLoading = true;
    this.getClientForISI(year, 'getOperationalTradeDV', this.operationalTradeDV);
    this.operationalProductionDV.isLoading = true;
    this.getClientForISI(year, 'getOperationalProductionDV', this.operationalProductionDV);
    this.dVBuitendirecteuren.isLoading = true;
    this.getClientForISI(year, 'getDVBuitendirecteuren', this.dVBuitendirecteuren);
    this.offBoardedClient.isLoading = true;
    this.getClientForISI(year, 'getOffBoardedClient', this.offBoardedClient);
    this.uboInNL.isLoading = true;
    this.getPersonForISI(year, 'getUBOFromNL', this.uboInNL);
    this.pepAndUBO.isLoading = true;
    this.getPersonForISI(year, 'getPEPUBO', this.pepAndUBO);
    this.countryWiseUBO.isLoading = true;
    this.getCountryWisePerson(year, 'UBOs', this.countryWiseUBO);
    this.countryWisePEP.isLoading = true;
    this.getCountryWisePerson(year, 'peps', this.countryWisePEP);
    this.countryWiseBranch.isLoading = true;
    this.getCountryWiseEntity(year, 'branches', this.countryWiseBranch);
    this.countryWiseParticipations.isLoading = true;
    this.getCountryWiseEntity(year, 'participations', this.countryWiseParticipations);
    this.countryWiseFeeders.isLoading = true;
    this.getCountryWiseEntity(year, 'feeders', this.countryWiseFeeders);
    this.structureDVWithTrusts.isLoading = true;
    this.getStructureWiseEntity(year, 'getDVWithTrusts', this.structureDVWithTrusts);
    this.structureDVWithTrustOfficeAsNomineeShareholder.isLoading = true;
    this.getStructureWiseEntity(year, 'getDVWithTrustOfficeAsNomineeShareholder', this.structureDVWithTrustOfficeAsNomineeShareholder);

  }
}



// WEBPACK FOOTER //
// ./src/app/reports/isi-report-detail/isi-report-detail.component.ts